'use client';
import { useEffect, useRef } from 'react';
import { usePreservedCallback } from './usePreservedCallback';
import { isNotNil } from 'es-toolkit';

type OneOrMore<T> = T | T[];

export function useOutsideClickEffect(container: OneOrMore<HTMLElement | null>, callback: () => void) {
  const containers = useRef<HTMLElement[]>([]);

  const handleDocumentClick = usePreservedCallback(({ target }: MouseEvent | TouchEvent) => {
    if (target === null) {
      return;
    }

    if (containers.current.length === 0) {
      return;
    }

    if (containers.current.some((x) => x.contains(target as Node))) {
      return;
    }
    setTimeout(() => callback(), 0);
  });

  useEffect(() => {
    containers.current = [container].flat(1).filter(isNotNil);
  }, [container]);

  useEffect(() => {
    document.addEventListener('click', handleDocumentClick);

    return () => {
      document.removeEventListener('click', handleDocumentClick);
    };
  }, [handleDocumentClick]);
}
